import React from "react";
import { Link } from "react-router-dom";
import { helpRingBox } from "./helpPage.data";
import "./HelpHero.scss";

const HelpHero = () => (
  <section className="help-hero">
    <div className="help-hero__copy">
      <p className="help-label">TrueKarat support</p>
      <h1>Help center</h1>
      <p>
        Clear answers for choosing jewelry, checking out, caring for pieces,
        and finding order details after payment.
      </p>
      <div className="help-hero__actions">
        <Link to="/cart" className="help-button help-button--primary">
          Checkout help
        </Link>
        <Link to="/products" className="help-button">
          Continue shopping
        </Link>
      </div>
    </div>
    <div className="help-hero__image">
      <img src={helpRingBox} alt="Ring displayed in a black jewelry box" />
    </div>
  </section>
);

export default HelpHero;
